"use client";

import { CinematicMenu as UICinematicMenu } from "@jesus-central-church/ui";
import { StoryblokMultilink } from "@storyblok/types/storyblok";
import { linkResolver } from "../../../lib/storyblok";

interface CinematicMenuProperties {
  menu_data?: {
    title: string;
    items: {
      label: string;
      link: StoryblokMultilink;
      open_in_new_tab?: boolean;
    }[];
  }[];
  social_links?: {
    label: string;
    url: string;
  }[];
}

export function CinematicMenu({
  menu_data,
  social_links,
}: CinematicMenuProperties) {
  // Transform Storyblok data to UI component format
  const menuSections =
    menu_data?.map((section) => ({
      title: section.title || "",
      items:
        section.items?.map((item) => ({
          label: item.label || "",
          href: linkResolver(item.link) || "#",
          target: item.open_in_new_tab ? "_blank" : undefined,
        })) || [],
    })) || [];

  const socialLinks =
    social_links?.map((link) => ({
      label: link.label || "",
      href: link.url || "#",
    })) || [];

  return (
    <UICinematicMenu
      menuSections={menuSections}
      socialLinks={socialLinks.map((link) => ({
        ...link,
        icon: undefined, // Provide a default or placeholder icon if needed
      }))}
    />
  );
}
